import React,{useState, useEffect} from "react";
import "./App.css";
import Login from './Login';
import  firebase from './components/page/firebaseConfig'
import Home from './components/home';
import { FlashOnRounded } from "@material-ui/icons";



const App =() =>{
    const [user, setUser] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [hasAccount, setHasAccount] = useState(true);
    const [loginNumber, setLoginNumber] = useState(' ');

    const clearInputs = () =>{
        setEmail('');
        setPassword(' ');
    }

    const clearErrors = () =>{
        setEmailError('');
        setPasswordError('');
    } 
    const handleLogin = () =>
    {
        clearErrors();
        firebase
         .auth()
         .signInWithEmailAndPassword(loginNumber,password)
         .catch(err =>{
             switch(err.code){
                 case "auth/invalid-email":
                 case "auth/user-disabled":
                 case "auth/user-not-found":
                     setEmailError(err.message);
                     break;

                 case "auth/wrong-password":
                     setPasswordError(err.message);
                     break;
                 default: 
                      break;
             }
         });
    };

    const handleSignup = () =>{
        clearErrors();
        firebase
        .auth()
        .createUserWithEmailAndPassword(email,password)
        .catch(err =>{
            switch(err.code){
                case "auth/email-already-in-use":
                case "auth/invalid-email":
                    setEmailError(err.message);
                    break;

                case "auth/weak-password":
                    setPasswordError(err.message);
                    break;
                default: 
                    break;

            }   
        });
        //firebase.auth().onAuthStateChanged();
    };

    const handleLogout = () =>{
        firebase.auth().signOut();
    };

     const authListener = () =>
     {
        firebase.auth().onAuthStateChanged(user =>{
            if(user){
                clearInputs();
                setUser(user);
            }
            else
            {
                setUser('');
            }
         });
     };

    useEffect(() =>{
        handleLogout();
         authListener();
    },[]);

    return(
        <div className ="App">
            {user ?(
               <Home handleLogout={handleLogout}/>
            ):(

                <Login
            email={email}
            setEmail={setEmail}
            password={password}
            setPassword={setPassword}
            handleLogin={handleLogin}
            handleSignup={handleSignup}
            hasAccount={hasAccount}
            setHasAccount={setHasAccount}
            emailError={emailError}
            passwordError={passwordError}
            setLoginNumber={setLoginNumber}
            />
            )}
            
           
        </div>
    );
};
export default App;